import React, { useState } from "react";
import toast from "react-hot-toast";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";
import logo from "../../assets/Sankrutilogo.jpeg";

const Footer = () => {
  const [expandedSections, setExpandedSections] = useState({
    quickLinks: false,
    contactUs: false,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <footer className={styles.footerContainer}>
      {/* Background Decorative Leaves for Footer */}
      <svg className={styles.footerBgLeafLeft} viewBox="0 0 200 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 50C50 50 100 100 100 200C100 300 50 350 0 350" stroke="rgba(255,255,255,0.05)" strokeWidth="2"/>
        <path d="M0 100C40 100 80 140 80 200C80 260 40 300 0 300" stroke="rgba(255,255,255,0.05)" strokeWidth="2"/>
        <path d="M0 150C30 150 60 170 60 200C60 230 30 250 0 250" stroke="rgba(255,255,255,0.05)" strokeWidth="2"/>
        <path d="M40 100C70 70 120 70 150 100C150 100 120 120 100 200" stroke="rgba(255,255,255,0.05)" strokeWidth="2"/>
      </svg>
      <svg className={styles.footerBgLeafRight} viewBox="0 0 200 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 50C50 50 100 100 100 200C100 300 50 350 0 350" stroke="rgba(255,255,255,0.05)" strokeWidth="2"/>
        <path d="M0 100C40 100 80 140 80 200C80 260 40 300 0 300" stroke="rgba(255,255,255,0.05)" strokeWidth="2"/>
        <path d="M0 150C30 150 60 170 60 200C60 230 30 250 0 250" stroke="rgba(255,255,255,0.05)" strokeWidth="2"/>
        <path d="M40 100C70 70 120 70 150 100C150 100 120 120 100 200" stroke="rgba(255,255,255,0.05)" strokeWidth="2"/>
      </svg>

      <div className={styles.footerTop}>
        
        {/* Brand Section */}
        <div className={`${styles.footerSection} ${styles.brandSection}`}>
          <Link to="/" className={styles.logoContainer} style={{ textDecoration: 'none' }}>
            <div className={styles.logoIcon}>
              <img
                src={logo}
                alt="Sanskriti Shubh Aangan"
                className={styles.logo}
              />
            </div>
          </Link>
          <p className={styles.brandDescription}>
            A secure and harmonious residential community dedicated to a better and peaceful living.
          </p>
          <div className={styles.socialLinks}>
            <a href="#" className={styles.socialIcon} aria-label="Facebook">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
            </a>
            <a href="#" className={styles.socialIcon} aria-label="Instagram">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
            </a>
            <a href="#" className={styles.socialIcon} aria-label="Twitter">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
            </a>
            <a href="#" className={styles.socialIcon} aria-label="YouTube">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33 2.78 2.78 0 0 0 1.94 2c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className={`${styles.footerSection} ${styles.accordionSection}`}>
          <div className={styles.sectionHeader} onClick={() => toggleSection('quickLinks')}>
            <h3 className={styles.sectionTitle}>Quick Links</h3>
            <svg className={`${styles.chevron} ${expandedSections.quickLinks ? styles.expanded : ''}`} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </div>
          <div className={`${styles.sectionContent} ${expandedSections.quickLinks ? styles.showContent : ''}`}>
            <ul className={styles.footerList}>
              <li><Link to="/"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg> Home</Link></li>
              <li><Link to="/about"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg> About Us</Link></li>
              <li><Link to="/amenities"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg> Amenities</Link></li>
              <li><Link to="/events"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg> Events</Link></li>
              <li><Link to="/notices"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg> Notices</Link></li>
              <li><Link to="/business"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg> Business</Link></li>
              <li><Link to="/gallery"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg> Gallery</Link></li>
              <li><Link to="/contact"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg> Contact</Link></li>
            </ul>
          </div>
        </div>

        {/* Contact Us */}
        <div className={`${styles.footerSection} ${styles.accordionSection}`}>
          <div className={styles.sectionHeader} onClick={() => toggleSection('contactUs')}>
            <h3 className={styles.sectionTitle}>Contact Us</h3>
            <svg className={`${styles.chevron} ${expandedSections.contactUs ? styles.expanded : ''}`} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </div>
          <div className={`${styles.sectionContent} ${expandedSections.contactUs ? styles.showContent : ''}`}>
            <div className={styles.contactList}>
              <div className={styles.contactItem}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                <span>+91 99209 09082</span>
              </div>
              <div className={styles.contactItem}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                <span>sanskrutishubhaangan@gmail.com</span>
              </div>
              <div className={styles.contactItem}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <span>193, Sanskriti Shubh Aangan,<br/>Talawali Chanda, Manglia,<br/>Indore – 453771, Madhya Pradesh</span>
              </div>
              <div className={styles.contactItem}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                <span>Mon - Sat : 9:00 AM - 6:00 PM</span>
              </div>
            </div>
          </div>
        </div>

        </div>

      <div className={styles.footerBottom}>
        <div className={styles.footerBottomContent}>
          <p>
            Designed & Developed by{" "}
            <a
              href="https://gnvindiatechverse.com/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.developerLink}
            >
              GNVIndia Techverse
            </a>
          </p>
          <div className={styles.footerLegal}>
            <Link to="/privacy">Privacy Policy</Link>
            <span className={styles.legalDivider}>|</span>
            <Link to="/terms">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;